
        require('./index.scss');
        'use strict';

var _jiaMeng = require('../../../model/service/jia-meng.js');

var _jiaMeng2 = _interopRequireDefault(_jiaMeng);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ = window.$; /*
                   * @Author: finian
                   * @Date: 2021-01-25 14:42:05
                   * @LastEditors: your name
                   * @LastEditTime: 2021-01-28 10:20:41
                   */

var $$cookie = require('assets/util/cookie.js');
var _ = window._;
var $mod = $('.module-modal');
var $closeIcon = $mod.find('.close-icon');
// const $modalWrapper = $mod.find('.modal-wrapper');

$closeIcon.click(function () {
    $mod.hide();
});

function isPlaceholer() {
    var input = document.createElement('input');
    return 'placeholder' in input;
}

if (!isPlaceholer()) {
    console.log('不兼容placeholder');
    $mod.find('.input-item').each(function (index, item) {
        if ($(item).val() == '') {
            $(item).css({
                'color': '#ccc'
            });
            $(item).val($(this).data('placeholder'));
        }
    });

    $mod.find('.input-item').focus(function () {
        $('#search').css({
            'color': '#000'
        });
        if ($(this).val() == $(this).data('placeholder')) {
            $(this).val('');
        }
    });

    $mod.find('.input-item').blur(function () {
        if ($(this).val() == '') {
            $(this).val($(this).data('placeholder'));
            $('#search').css({
                'color': '#ccc'
            });
        } else {
            $('#search').css({
                'color': '#000'
            });
        }
    });
}

var joinName = $mod.find('[node-type="join-name"]');
var joinPhone = $mod.find('[node-type="join-phone"]');
var joinAgent = $mod.find('[node-type="join-agent"]');
var joinSubmit = $mod.find('[node-type="join-submit"]');
var preSubData = {};
function EmptyInput() {
    joinName.val('');
    joinPhone.val('');
    joinAgent.val('');
    $mod.find('[node-type="jm-nav-content"] input').removeClass('text-black');
}
var checkItems = {
    nameFn: function nameFn() {
        if (!/^[\u4e00-\u9fa5]+$/.test(joinName.val()) || joinName.val().length > 6 || joinName.val() === joinName.data('placeholder')) {
            joinName.siblings('[node-type="warn-tag"]').show().delay(2000).fadeOut('slow');
            return false;
        }
        return true;
    },
    phoneFn: function phoneFn() {
        var phonetest1 = /^(\+\d+)?1[3458]\d{9}$/.test(joinPhone.val());
        var phonetest2 = /^(\+\d+)?(\d{3,4}-?)?\d{7,8}$/.test(joinPhone.val());
        if (!(phonetest1 || phonetest2) || joinPhone.val() === joinPhone.data('placeholder')) {
            joinPhone.siblings('[node-type="warn-tag"]').show().delay(2000).fadeOut('slow');
            return false;
        }
        return true;
    },
    agentFn: function agentFn() {
        if (joinAgent.val().length > 20 || joinAgent.val().length <= 0 || joinAgent.val() === joinAgent.data('placeholder')) {
            joinAgent.siblings('[node-type="warn-tag"]').show().delay(2000).fadeOut('slow');
            return false;
        }
        return true;
    }
};
var submitFun = function submitFun() {
    if (checkItems.nameFn() && checkItems.phoneFn() && checkItems.agentFn()) {
        var submitData = {
            name: joinName.val(),
            phone: joinPhone.val(),
            agentCity: joinAgent.val()
        };
        // 重复提交同一内容判断
        if (preSubData.name == submitData.name && preSubData.phone == submitData.phone && preSubData.agentCity == submitData.agentCity) {
            $mod.find('[node-type="jm-text"]').text('请勿重复提交！');
            $mod.find('[node-type="jm-return"]').show();
            return;
        } else {
            preSubData.name = submitData.name;
            preSubData.phone = submitData.phone;
            preSubData.agentCity = submitData.agentCity;
        }
        // 每天提交最多三次判断
        var countInfo = parseInt($$cookie.getCookie('jiamengCount'));
        if (countInfo) {
            if (countInfo <= 3) {
                $$cookie.setCookie('jiamengCount', countInfo + 1);
            } else {
                EmptyInput();
                $mod.find('[node-type="jm-text"]').text('每天最多能提交三次！');
                $mod.find('[node-type="jm-return"]').show();
            }
        } else {
            $$cookie.setCookie('jiamengCount', 1);
        }
        console.log(submitData, 'submitData');
        _jiaMeng2['default'].jiaMengSubmit(submitData).then(function (res) {
            if (res && res.code == 200) {
                EmptyInput();
                $mod.find('[node-type="jm-text"]').text('信息提交成功！我们的工作人员会尽快联系你，敬请期待！');
                $mod.find('[node-type="jm-return"]').hide();
            } else {
                $mod.find('[node-type="jm-text"]').text(res.msg);
            }
            $mod.find('[node-type="jm-return"]').show();
        });
    }
};
var submitFn = _.throttle(submitFun, 200);
joinSubmit.click(function () {
    submitFn();
});
$mod.find('[node-type="jm-close"]').click(function () {
    $mod.find('[node-type="jm-return"]').hide();
});;
    


// WEBPACK FOOTER //
// ./src/module/jiameng/modal/index.js